<template>
  <!-- 其他维度分析报告 -->
  <div class="page">
    <div class="paginations" :style="{filter: this.$store.state.isVague?'blur(2px)':''}">
      <div class="table_box">
        <el-table :data="tableList" style="width: 100%">
          <el-table-column prop="statisticsType" label="月统计类型" align='center'>
          </el-table-column>
          <el-table-column prop="createTimeStr" label="统计日期" align='center'>
          </el-table-column>
          <el-table-column label="操作" align='center'>
            <template slot-scope="scope">
              <i class="icona icon-see" :title="scope.row.statisticsType" @click="see(scope.row.statisticsType,scope.row.createTimeStr)"></i>
              <i class="icona icon-downloadExcel" title="下载Excel" @click="downloads(scope.row.statisticsType,scope.row.zykid)"></i>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <!-- 查询详情信息 -->
    <el-dialog :title="detailsBox1.title" :visible.sync="detailsBox1.show" :close-on-click-modal="false" width="1200px" class="pop_up distribute" append-to-body :before-close="handleClose">
      <div class="table_box tableBox">
        <el-table :data="detailsBox1.list" style="width: 100%" height="600">
          <el-table-column type="index" label="序号" align='center'></el-table-column>
          <el-table-column prop="coursename" label="课程名称" align='center'></el-table-column>
          <el-table-column prop="anchor" label="负责人" align='center'></el-table-column>
          <el-table-column prop="schoolname" label="所在院校" align='center'></el-table-column>
          <el-table-column label="使用单位" align='center'>
            <el-table-column prop="unitnum" label="数量" width="120">
            </el-table-column>
            <el-table-column prop="unitrank" label="排名" width="120">
            </el-table-column>
          </el-table-column>
          <el-table-column label="注册学生" align='center'>
            <el-table-column prop="studentnum" label="人数" width="120">
            </el-table-column>
            <el-table-column prop="studentrank" label="排名" width="120">
            </el-table-column>
          </el-table-column>
          <el-table-column label="活跃学生" align='center'>
            <el-table-column prop="studentactivenum" label="人数" width="120">
            </el-table-column>
            <el-table-column prop="studentactiverank" label="排名" width="120">
            </el-table-column>
          </el-table-column>
          <el-table-column label="使用教师" align='center'>
            <el-table-column prop="teachernum" label="人数" width="120">
            </el-table-column>
            <el-table-column prop="teacherrank" label="排名" width="120">
            </el-table-column>
          </el-table-column>
          <el-table-column label="发回帖" align='center'>
            <el-table-column prop="forumnum" label="数量" width="120">
            </el-table-column>
            <el-table-column prop="forumrank" label="排名" width="120">
            </el-table-column>
          </el-table-column>
          <el-table-column label="资源点击" align='center'>
            <el-table-column prop="resourceclicknum" label="数量" width="120">
            </el-table-column>
            <el-table-column prop="resourceclickrank" label="排名" width="120">
            </el-table-column>
          </el-table-column>
          <el-table-column label="作业提交" align='center'>
            <el-table-column prop="tasksubmitnum" label="数量" width="120">
            </el-table-column>
            <el-table-column prop="tasksubmitrank" label="排名" width="120">
            </el-table-column>
          </el-table-column>
          <el-table-column prop="sumrank" label="综合排名" align='center'></el-table-column>
          <el-table-column prop="matchlastrank" label="与上期相比" align='center'></el-table-column>
        </el-table>
      </div>
      <pageNumber :paginations="7" :pageNum="detailsBox1.data.pageNum" :pageSize="detailsBox1.data.pageSize" :total="detailsBox1.total" :jumpTo="detailsBox1.jumpTo" @currentChange="seeDetails1"></pageNumber>
    </el-dialog>

    <el-dialog :title="detailsBox2.title" :visible.sync="detailsBox2.show" :close-on-click-modal="false" width="1300px" class="pop_up distribute" append-to-body :before-close="handleClose">
      <div class="table-search-box">
        <span>参建院校资源库应用统计({{detailsBox2.data.createTime}})</span>
        <el-date-picker v-model="detailsBox2.data.createTime" type="month" placeholder="选择月" @change="monthChange" :clearable='false' value-format="yyyy-MM" popper-class="dateClass">
        </el-date-picker>
      </div>

      <div class="table_box tableBox">
        <el-table :data="detailsBox2.list" style="width: 100%">
          <el-table-column prop="school" label="单位名称" align='center'></el-table-column>
          <el-table-column prop="courseNum" label="使用课程数" align='center'></el-table-column>
          <el-table-column prop="regTeacherNum" label="实名注册教师数" align='center'></el-table-column>
          <el-table-column prop="activeTeacherNum" label="实际使用教师数" align='center'></el-table-column>
          <el-table-column prop="regStudentNum" label="实名注册学生数" align='center'></el-table-column>
          <el-table-column prop="activeStudentNum" label="实际使用学生数" align='center'></el-table-column>
          <el-table-column prop="joinActiveNum" label="参与互动人次" align='center'></el-table-column>
          <el-table-column prop="forumNum" label="发帖回帖数" align='center'></el-table-column>
          <el-table-column prop="downloadNum" label="资源点击下载数" align='center'></el-table-column>
          <el-table-column prop="homeworkNum" label="作业提交数" align='center'></el-table-column>
        </el-table>
      </div>
      <pageNumber :paginations="7" :pageNum="detailsBox2.data.pageDto.pageNum" :pageSize="detailsBox2.data.pageDto.pageSize" :total="detailsBox2.total" :jumpTo="detailsBox2.jumpTo" @currentChange="seeDetails2"></pageNumber>
    </el-dialog>

  </div>
</template>

<script>
import pageNumber from '@/components/pageNumber.vue'; // 分页

export default {
  components: {
    pageNumber,
  },
  data() {
    return {
      tableList: [],

      // 弹窗
      detailsBox1: {
        title: '查询详情信息',
        show: false,
        list: [], // 资源库标准化课程应用排名情况,参建院校资源库应用情况
        data: {
          pageNum: 1, // 当前显示的页面页码数
          pageSize: 10, // 一页多少条数据
        },
        total: 0,
        jumpTo: 1,
      },

      detailsBox2: {
        title: '查询详情信息',
        show: false,
        detailsName: '',
        list: [], // 资源库标准化课程应用排名情况,参建院校资源库应用情况
        data: {
          createTime: '', // 选择的月份
          pageDto: {
            pageNum: 1, // 当前显示的页面页码数
            pageSize: 10, // 一页多少条数据
          },
        },
        total: 0,
        jumpTo: 1,
      },
    };
  },
  created() {
    // let yy = new Date().getFullYear();
    // let mm = new Date().getMonth() + 1;
    // this.detailsBox2.data.createTime = yy + '-' + mm

    this.getList();
  },
  methods: {
    // 获取表格数据
    getList() {
      this.$axios.post(this.$apiurls.analysisReport_getList, {
        loading: false,
      }).then((res) => {
        if (res) {
          this.tableList = res.data;
        }
      });
    },
    // 查看
    see(name, createTimeStr) {
      if (name === '资源库标准化课程应用排名情况') {
        this.seeDetails1();
      } else if (name === '参建院校资源库应用情况') {
        this.seeDetails2();
        this.detailsBox2.data.createTime = createTimeStr;
      }
    },
    // 资源库标准化课程应用排名情况详情
    seeDetails1(type) {
      this.detailsBox1.data.pageNum = type || 1;
      this.detailsBox1.jumpTo = type || 1;
      this.$axios.post(this.$apiurls.applicationReport_resourceBase, this.detailsBox1.data, {
        loading: false,
      }).then((res) => {
        if (res) {
          this.detailsBox1.list = res.data.list;
          this.detailsBox1.total = res.data.total;
          this.detailsBox1.show = true;
          this.$store.commit('modifyVague', true);
        }
      });
    },
    // 参建院校资源库应用情况
    seeDetails2(type) {
      this.detailsBox2.data.pageDto.pageNum = type || 1;
      this.detailsBox2.jumpTo = type || 1;
      this.$axios.post(this.$apiurls.applicationReport_universities, this.detailsBox2.data, {
        loading: false,
      }).then((res) => {
        if (res) {
          this.detailsBox2.list = res.data.list;
          this.detailsBox2.total = res.data.total;
          this.detailsBox2.show = true;
          this.$store.commit('modifyVague', true);
        }
      });
    },
    // 选择月份
    monthChange() {
      this.seeDetails2();
    },
    // 下载
    downloads(row, zykid) {
      if (row === '资源库标准化课程应用排名情况') {
        window.open(`${this.$apiurls.applicationReport_getStandardCourseApplyRankExcel}?zykid=${zykid}`);
      } else {
        window.open(`${this.$apiurls.applicationReport_getZykWeekSchoolResultExcelDetail}?zykid=${zykid}`);
      }
    },
    // 关闭弹窗
    handleClose() {
      this.detailsBox1.show = false;
      this.detailsBox2.show = false;
      this.$store.commit('modifyVague', false);
    },
  },
};
</script>

<style  lang="scss" src="@/assets/css/popUp.scss" scoped></style>
<style  lang="scss" src="@/assets/css/tableList.scss" scoped></style>
<style lang="scss" scoped>
.paginations {
  position: relative;
  width: 100%;
  height: 100%;
  overflow-y: auto;
}

.table-search-box {
  color: #fff;
  margin-bottom: 10px;
}
.table-search-box span {
  margin-right: 20px;
}

// 行间距
.tableBox ::v-deep .el-table__body {
  border-spacing: 0px 0px;
}

.tableBox ::v-deep .el-table thead.is-group th.el-table__cell {
  background: rgba(31, 50, 94, 0.8);
  border-bottom: 1px solid #39456e !important;
  border-right: 1px solid #39456e !important;
}

.tableBox ::v-deep .el-table tr {
  background: rgba(35, 42, 67, 1);
}

.tableBox ::v-deep .el-table--enable-row-hover .el-table__body tr td {
  border-bottom: 1px solid #39456e !important;
  color: #fff;
  border-right: 1px solid #39456e !important;
}

.tableBox ::v-deep .el-table--border,
.tableBox ::v-deep .el-table--group {
  border-width: 0px;
}

.tableBox ::v-deep .el-table--border::after,
.tableBox ::v-deep .el-table--group::after {
  width: 0px !important;
}
</style>
